export enum EbpCaseStatus {
  started = 'started',
  discharged = 'discharged',
}

export const ebpCaseFinalStatuses = [EbpCaseStatus.discharged];
